import React from "react";
import cn from "classnames";

import { useSelector } from "react-redux";

import { coreActions } from "src/store/slices";
import { getIsLimit, getMax } from "./selectors";
import { getBalanceId, getLimit } from "src/selectors";
import { useAppDispatch, useContent } from "src/hooks";
import { BALANCES } from "src/constants";

import styles from "./style.module.scss";

export const useLimit = () => {
  const content = useContent();

  const dispatch = useAppDispatch();

  const balanceId = useSelector(getBalanceId);
  const isLimit = useSelector(getIsLimit);
  const max = useSelector(getMax);

  const limit = useSelector(getLimit);

  React.useEffect(() => {
    let limitTimeout: NodeJS.Timeout;

    if (isLimit) {
      limitTimeout = setTimeout(() => dispatch(coreActions.limitRemoved()), 2000);
    }

    return () => {
      if (limitTimeout) {
        clearTimeout(limitTimeout);
      }
    };
  }, [dispatch, isLimit, limit.uuid]);

  const getLimitProps = React.useCallback(
    () => ({
      className: cn(styles[content], {
        [styles.active]: isLimit,
      }),
    }),
    [content, isLimit]
  );

  const values = React.useMemo(
    () => ({
      balanceLabel: BALANCES[balanceId] ?? "₽",
      max,
      styles,
    }),
    [balanceId, max]
  );

  return { getLimitProps, values };
};
